import { kioskApi } from '../axios.js';
export const translationApi = {
    generateTranslations: (shopId, targetLanguage) => kioskApi.post(`/translations/${shopId}/generate`, { targetLanguage }),
    getJobStatus: (shopId, targetLanguage) => {
        const params = targetLanguage ? { targetLanguage } : {};
        return kioskApi.get(`/translations/${shopId}/jobs`, { params });
    },
    getRecipesWithTranslations: (shopId, language) => {
        const params = language ? { language } : {};
        return kioskApi.get(`/translations/${shopId}/recipes`, { params });
    },
    updateRecipeTranslation: (shopId, recipeId, fieldName, language, translatedText) => kioskApi.patch(`/translations/${shopId}/recipes/${recipeId}`, {
        fieldName,
        language,
        translatedText
    }),
    updateIngredientTranslation: (shopId, ingredientId, language, translatedText) => kioskApi.patch(`/translations/${shopId}/ingredients/${ingredientId}`, {
        language,
        translatedText
    }),
    getSupportedLanguages: () => kioskApi.get('/translations/languages'),
    getRecipesDebug: (shopId) => kioskApi.get(`/translations/${shopId}/recipes/debug`)
};
